export default (number) => {
  if (number) {
    const noCommas = number.replace(/,/g,'')
    const noLeadingZeros = noCommas.replace(/^0+/, '')
    const newNumber = noLeadingZeros.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    return (newNumber)
  } else {
    return null
  }
}
